module.exports = __webpack_public_path__ + "static/media/april-lose.d3d9cfda.png";